export const FETCH_LOCATIONS_START = 'ott/activities/suggest/fetchLocationsStart';
export const FETCH_LOCATIONS_SUCCESS = 'ott/activities/suggest/fetchLocationsSuccess';
export const FETCH_LOCATIONS_FAIL = 'ott/activities/suggest/fetchLocationsFail';
export const SELECT_LOCATION = 'ott/activities/suggest/selectLocation';
export const SET_QUEUE = 'ott/activities/suggest/setQueue';
